import { Component, EventEmitter, ViewChild, TemplateRef, Input, Output, ElementRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms/qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';


@Component({
  selector: 'app-moduletype',
  templateUrl: './moduletype.component.html',
  styleUrls: ['./moduletype.component.scss']
})
export class ModuletypeComponent {

  @Output() valueEmitter = new EventEmitter<any>();
  @Input() parentData: any;

  dvTypesearchTxt: any = "";
  isdvTypeOdd: any;
  moduleTypeValue: string = "";
  expcetedClosureOn: any = null;
  expectedToBeStartedOn: any = null;
  justification: string = '';
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(
    readonly dialog: MatDialog,
    readonly message: messageService,
    readonly qmsservice: qmsService,

    private readonly appService: AppService,
    private readonly snackBar: MatSnackBar,
    private readonly elem: ElementRef) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };
  isProcessing: any = false;
  moduleTypeDropdown: any = [];
  validationErrors: any = {};

  @ViewChild('moduleTypePopup', { static: true }) moduleTypePopup: TemplateRef<any>;
  visiblemoduleTypePopup: MatDialogRef<TemplateRef<any>>;

  angularEditorPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  dateTimePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: true,
    todayPosition: 'center'
  };
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: true,
    todayPosition: 'center'
  };
  $present_future_config = {
    ...this.commonDateConfig,
    minDate: new Date(),
    showTodayButton: false
  };

  $past_present_config = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  onExpectedToBeStartedOnChange() {
    // Clear validation error when user selects a date
    if (this.expectedToBeStartedOn) {
      this.validationErrors.expectedToBeStartedOn = false;
    }

    if (this.expcetedClosureOn && (this.expcetedClosureOn < this.expectedToBeStartedOn)) this.expcetedClosureOn = null;
  }

  $expected_closure_dynamic_config() {
    return {
      ...this.commonDateConfig,
      minDate: this.expectedToBeStartedOn ? new Date(this.expectedToBeStartedOn) : new Date(),
      showTodayButton: false
    };
  }

  openpopup(data: any) {
    this.parentData = data;
    this.moduleTypeDropdown = [];
    this.moduleTypeValue = this.parentData.moduleTypeValue;
    this.expectedToBeStartedOn = this.parentData.expectedToBeStartedOn;
    this.expcetedClosureOn = this.parentData.expcetedClosureOn;
    this.moduleTypeDropdown = this.parentData.dropdownList;
    this.justification = '';
    this.visiblemoduleTypePopup = this.dialog.open(this.moduleTypePopup, this.angularEditorPopupConfig);
  };


  onExpectedClosureOnChange() {
    // Clear validation error when user selects a date
    if (this.expcetedClosureOn) {
      this.validationErrors.expcetedClosureOn = false;
    }
  }


  onModuleTypeChange() {
    // Clear validation error when user makes a selection
    if (this.moduleTypeValue && this.moduleTypeValue.trim() !== '') {
      this.validationErrors.moduleType = false;
    }
  }
  showChangeTypeIfNa: boolean = false;
  isStartedOnConfiguredInGroup: boolean = true;
  isClosureOnConfiguredInGroup: boolean = true;
  onmoduleTypeTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.isProcessing = true;

        if (item.valueExp == 'NA') {
          this.showChangeTypeIfNa = true;
          this.isProcessing = false;
        } else {
          this.appService.getTypeSettingsByType(this.qmsservice.selectedActivityGroupId, this.qmsservice.selectedGroupDetailId, ((this.qmsservice.moduleName == "AU" ? 'Findings-' : '') + item.valueExp)).subscribe((response: any) => {
            if (response?.toBeStartedInDays != null) {
              let date = this.qmsservice.moduleName === 'AU' ? new Date(this.qmsservice.activity.peerReviewCompletedOn) : new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              date.setDate(date.getDate() + response.toBeStartedInDays);
              this.expectedToBeStartedOn = date;
              this.isStartedOnConfiguredInGroup = true;
            } else {
              this.expectedToBeStartedOn = null;
              this.isStartedOnConfiguredInGroup = false;
            }

            if (response?.toBeClosedInDays != null) {
              let date = this.qmsservice.moduleName === 'AU' ? new Date(this.qmsservice.activity.peerReviewCompletedOn) : new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              this.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
              this.expcetedClosureOn = date;
              this.isClosureOnConfiguredInGroup = true;
            } else {
              this.expcetedClosureOn = null;
              this.isClosureOnConfiguredInGroup = false;
            }
            this.isProcessing = false;
          });
          this.showChangeTypeIfNa = false;
        }
      }
    }
  }

  saveEditor() {
    // Reset validation errors
    this.validationErrors = {};
    let validationMessage = '';

    // Validate mandatory fields
    if (!this.moduleTypeValue || this.moduleTypeValue.trim() === '') {
      this.validationErrors.moduleType = true;
      validationMessage += `${this.parentData.moduleName} is required\n`;
    }

    // Validate Expected to be Started On date (only if not hidden for AU module)
    if (this.qmsservice.moduleName !== 'AU' && this.qmsservice.activityDynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y' && (!this.expectedToBeStartedOn || this.expectedToBeStartedOn === null)) {
      this.validationErrors.expectedToBeStartedOn = true;
      validationMessage += `Expected to be ${this.parentData.moduleStartedOnName} is required\n`;
    }

    // Validate Expected Closure On date (only if not hidden for AU module)
    if (this.qmsservice.moduleName !== 'AU' && (!this.expcetedClosureOn || this.expcetedClosureOn === null)) {
      this.validationErrors.expcetedClosureOn = true;
      validationMessage += `Expected to be ${this.parentData.moduleclosedOnName} is required\n`;
    }

    if (!this.justification) {
      validationMessage += `Justification is required`;
    }

    // If there are validation errors, show alert and focus on first error
    if (validationMessage) {
      alert(validationMessage.trim());

      // Focus on the first invalid field for better UX
      if (this.validationErrors.moduleType) {
        const deviationTypeElement = document.getElementById('deviationType-validation');
        if (deviationTypeElement) {
          deviationTypeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          deviationTypeElement.focus();
        }
      } else if (this.validationErrors.expectedToBeStartedOn) {
        const expectedStartElement = document.getElementById('expectedToBeStartedOn-validation');
        if (expectedStartElement) {
          expectedStartElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          expectedStartElement.focus();
        }
      } else if (this.validationErrors.expcetedClosureOn) {
        const expectedClosureElement = document.getElementById('expcetedClosureOn-validation');
        if (expectedClosureElement) {
          expectedClosureElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          expectedClosureElement.focus();
        }
      }
      return;
    }

    let data = {
      moduleType: this.moduleTypeValue,
      expectedToBeStartedOn: this.expectedToBeStartedOn,
      expcetedClosureOn: this.expcetedClosureOn,
      typeUpdateJustification: this.justification
    };
    this.executeparentCall(data);
    console.log(this.moduleTypeValue);
    this.visiblemoduleTypePopup.close();
  }
  cancelEditor() {
    this.visiblemoduleTypePopup.close();
  }

  executeparentCall(data: any) {
    this.valueEmitter.emit(data);
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  limitCharacters(event: Event, field: string) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    const fieldMapping: { [key: number]: string[] } = {
      4000: ['JUSTIFICATION'],
    };

    let charLimit = 4000;
    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }
    if (textLength > charLimit) {
      this.showSnackBar(`Maximum ${charLimit} characters allowed!`, 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  snackbarRef: any;

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: !this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.secondLevel
          : this.message.breadcrumbData.thirdLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }
}
